const Contacto = props => {
    
    const state = props.state;
    

    return (
      <>
        <h5 className="mb-3 text-secondary">Datos de Contacto</h5>
        <div>
            <div className="row">
                <div className="col-6 col-lg-6">
                    <div className="mb-3">
                        <label htmlFor="telefono-celular" className="form-label">Teléfono</label>
                        <div className="input-group mb-2 mr-sm-2">
                            <div className="input-group-text">+56 9</div>
                            <input maxLength={8} type="text" className="form-control" id="telefono" name="telefono" value={state.telefono} onChange={e => props.handleChangeSoloNum(e)} placeholder={(!state.telefono && props.error.telefono) ? props.error.telefono : undefined} style={props.error.telefono ? { borderColor: 'rgba(220,53,69,0.5)', backgroundColor: 'rgba(220,53,69,0.06)' } : undefined}/>
                        </div>
                        
                    </div>
                </div>

                <div className="col-6 col-lg-6">
                    <div className="mb-3">
                    <label htmlFor="confirmar-telefono-celular" className="form-label">Confirmar Teléfono:</label>
                        <div className="input-group mb-2 mr-sm-2">
                            <div className="input-group-text">+56 9</div>
                            <input maxLength={8} type="text" className="form-control" id="conftelefono" name="conftelefono"  value={state.conftelefono} onChange={e => props.handleChangeSoloNum(e)} placeholder={(!state.conftelefono && props.error.conftelefono) ? props.error.conftelefono : undefined} style={props.error.conftelefono ? { borderColor: 'rgba(220,53,69,0.5)', backgroundColor: 'rgba(220,53,69,0.06)' } : undefined}/>
                        </div>
                        
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email:</label>
                        <input type="email" className="form-control" id="email" name="email" value={state.email} onChange={e => props.handleOnChangeText(e)} placeholder={(!state.email && props.error.email) ? props.error.email : undefined} style={props.error.email ? { borderColor: 'rgba(220,53,69,0.5)', backgroundColor: 'rgba(220,53,69,0.06)' } : undefined}/>
                        
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="mb-3">
                        <label htmlFor="confirmar-email" className="form-label">Confirmar Email:</label>
                        <input type="email" className="form-control" id="confemail" name="confemail" value={state.confemail} onChange={e => props.handleOnChangeText(e)} placeholder={(!state.confemail && props.error.confemail) ? props.error.confemail : undefined} style={props.error.confemail ? { borderColor: 'rgba(220,53,69,0.5)', backgroundColor: 'rgba(220,53,69,0.06)' } : undefined}/>
                        
                    </div>
                </div>
            </div>
        </div>     


        <h5>Contacto Emergencia</h5>
        <div>
            <div className="row">
                <div className="col-md-6">
                    <div className="mb-3">
                        <label htmlFor="nombre_emergencia" className="form-label">Nombre:</label>
                        <div className="input-group mb-2 mr-sm-2">
                            <input type="text" className="form-control" id="nombre_emergencia" name="nombre_emergencia" value={state.nombre_emergencia} onChange={e => props.handleOnChangeText(e)} placeholder={(!state.nombre_emergencia && props.error.nombre_emergencia) ? props.error.nombre_emergencia : undefined} style={props.error.nombre_emergencia ? { borderColor: 'rgba(220,53,69,0.5)', backgroundColor: 'rgba(220,53,69,0.06)' } : undefined}/>
                        </div>
                        
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="mb-3">
                        <label htmlFor="telefono_emergencia" className="form-label">Teléfono</label>
                        <div className="input-group mb-2 mr-sm-2">
                            <div className="input-group-text">+56 9</div>
                            <input maxLength={8} type="text" className="form-control" id="telefono_emergencia" name="telefono_emergencia" value={state.telefono_emergencia} onChange={e => props.handleChangeSoloNum(e)} placeholder={(!state.telefono_emergencia && props.error.telefono_emergencia) ? props.error.telefono_emergencia : undefined} style={props.error.telefono_emergencia ? { borderColor: 'rgba(220,53,69,0.5)', backgroundColor: 'rgba(220,53,69,0.06)' } : undefined}/>
                        </div>
                        
                    </div>
                </div>

            </div>
        </div> 



      </>
    );
  }
  
export default Contacto;